import { mapGetters } from 'vuex';
import userAgentMixin from '@/mixins/userAgent';
import navBrowse from './nav-browse/nav-browse.vue';

export default {
  mixins: [
    userAgentMixin,
  ],
  components: {
    navBrowse,
  },
  props: {
    theme: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rotationIndex: 1,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    classModifiers() {
      return {
        'app-secondary-nav': true,
        [`app-secondary-nav--${this.theme}`]: this.theme,
      };
    },
  },
  methods: {
    handleOrientationChange() {
      setTimeout(() => {
        this.rotationIndex += 1;
      }, 300);
    },
  },
  created() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    if (this.isTablet || this.isIos) {
      this.handleOrientationChange();
    }
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-secondary-nav/app-secondary-nav.js